import React from 'react';
import { ReactComponent as NeedBiggerScreen } from 'assets/images/needBiggerScreen.svg';
import classes from './BiggerScreenPlaceHolder.module.scss';
import classNames from 'classnames';

export const BiggerScreenPlaceHolderView = () => {
  return (
    <div className={classes.Container}>
      <div className={classes.SvgContainer}>
        <NeedBiggerScreen />
      </div>
      <h3 className={classNames(classes.TextPlaceholder, classes.TitlePlaceholder)}>
        Oops, Size Matters! Switch to a larger screen.
      </h3>
      <p className={classes.TextPlaceholder}>
        It seems like your screen size might be a bit too small to access all of the SmarterQueue features. For the best
        experience, we recommend using a larger screen to fully benefit from the power of SmarterQueue.
      </p>
    </div>
  );
};
